/* Import Estilo */
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/* Import Bibliotecas */
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/* Import Componentes */
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';
import { validadorCPF, validadorCNPJ, validadorEmail, validadorNomeCompleto, validadorNumeroCelular, validadorDataNascimento, removerCaracteresEspeciais, converterDataParaYMD, formatadorCPF, formatadorCNPJ, mascaraCelular, mascaraTelefone } from '../../../../utils/Validadores/index.js';

/* Import Requisição API */
import api from '../../../../api';

export default function EditarCliente() {
    const [usuario_id, setIdUsuario] = useState();
    const [nome, setNome] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [sexo, setSexo] = useState('');
    const [tipoCliente, setTipoCliente] = useState('Atacadista');
    const [isCNPJ, setIsCNPJ] = useState(false);
    const [razaoSocial, setRazaoSocial] = useState('');
    const [inscricaoEstadual, setInscricaoEstadual] = useState('');
    const [inscricaoMunicipal, setInscricaoMunicipal] = useState('');
    const [telefone, setTelefone] = useState('');
    const [statusCliente, setStatusCliente] = useState('Ativo');
    const [texto, setTexto] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const id = location.state?.id;

    const [cep, setCep] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');

    const [modalAberto, setModalAberto] = useState(false);
    const caixaDeDialogo = useRef(null);

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const mostrarModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };
        buscarDadosUsuario();
    }, []);

    const buscarEnderecoPorCep = async (cep) => {
        if (cep.length !== 8) {
            setTexto('Por favor, insira um CEP válido com 8 dígitos.');
            mostrarModal();
            return;
        }
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const data = await response.json();
            if (data.erro) {
                setTexto('CEP não encontrado.');
                mostrarModal();
            } else {
                setLogradouro(data.logradouro || '');
                setBairro(data.bairro || '');
                setCidade(data.localidade || '');
                setEstado(data.uf || '');
            }
        } catch (error) {
            console.error('Erro ao buscar endereço:', error);
            setTexto('Erro ao buscar o endereço. Tente novamente mais tarde.');
            mostrarModal();
        }
    };

    const mascaraCep = (valor) => {
        return valor
            .replace(/\D/g, '')
            .replace(/(\d{5})(\d{3})/, '$1-$2')
            .slice(0, 9);
    };

    useEffect(() => {
        const buscarCliente = async () => {
            try {
                const response = await api.get(`/clientes/${id}`);
                console.log("Resposta da API:", response.data);

                const cliente = response.data.cliente;
                console.log("Cliente:", cliente);

                const cpfCnpjFormatado = cliente.cpf_cnpj.length === 11
                    ? formatadorCPF(cliente.cpf_cnpj)
                    : formatadorCNPJ(cliente.cpf_cnpj);

                setNome(cliente.nome);
                setCpfCnpj(cpfCnpjFormatado);
                setEmail(cliente.email);
                setCelular(cliente.celular ? mascaraCelular(cliente.celular) : '');
                setDataNascimento(cliente.data_nascimento ? new Date(cliente.data_nascimento).toLocaleDateString('pt-BR') : '');
                setSexo(cliente.sexo);
                setTipoCliente(cliente.nivel_acesso || 'Atacadista');
                setIsCNPJ(cliente.cpf_cnpj.length === 14);
                setRazaoSocial(cliente.razao_social || '');
                setInscricaoEstadual(cliente.inscricao_estadual || '');
                setInscricaoMunicipal(cliente.inscricao_municipal || '');
                setTelefone(cliente.telefone ? mascaraTelefone(cliente.telefone) : '');
                setStatusCliente(cliente.status_cliente || 'Ativo');
                const enderecos = cliente.enderecos || [];
                const endereco = enderecos[0] || {};

                setCep(endereco.cep || '');
                setLogradouro(endereco.logradouro || '');
                setNumero(endereco.numero || '');
                setComplemento(endereco.complemento || '');
                setBairro(endereco.bairro || '');
                setCidade(endereco.cidade || '');
                setEstado(endereco.estado || '');

            } catch (error) {
                console.log(error)
                setTexto("Erro ao carregar dados do cliente.");
                mostrarModal();
            }
        };

        buscarCliente();
    }, [id]);


    const atualizarCliente = async (event) => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    
        const cpfCnpjLimpo = removerCaracteresEspeciais(cpfCnpj);
        const celularLimpo = removerCaracteresEspeciais(celular);
    
        const validacoes = {
            nome: validadorNomeCompleto(nome),
            email: validadorEmail(email),
            celular: validadorNumeroCelular(celularLimpo),
            cpfCnpj:
                cpfCnpjLimpo.length === 11
                    ? validadorCPF(cpfCnpjLimpo)
                    : validadorCNPJ(cpfCnpjLimpo),
        };
    
        if (!validacoes.cpfCnpj) { setTexto("CPF/CNPJ inválido."); mostrarModal(); return; }
        if (!validacoes.nome) { setTexto("Informe o nome completo."); mostrarModal(); return; }
        if (!validacoes.email) { setTexto("E-mail inválido."); mostrarModal(); return; }
        if (!validacoes.celular) { setTexto("Celular inválido."); mostrarModal(); return; }
    
        if (cpfCnpjLimpo.length === 14 && !inscricaoEstadual) {
            setTexto('Inscrição Estadual é obrigatória para CNPJ.');
            mostrarModal();
            return;
        }

        const cliente = {
            nome,
            cpf_cnpj: removerCaracteresEspeciais(cpfCnpj),
            email,
            celular: removerCaracteresEspeciais(celular),
            data_nascimento: converterDataParaYMD(dataNascimento),
            sexo,
            nivel_acesso: tipoCliente,
            razao_social: isCNPJ ? razaoSocial : null,
            inscricao_estadual: isCNPJ ? inscricaoEstadual : null,
            inscricao_municipal: isCNPJ ? inscricaoMunicipal : null,
            telefone: telefone ? removerCaracteresEspeciais(telefone) : null,
            status_cliente: statusCliente
        };

        const endereco = {
            cep: removerCaracteresEspeciais(cep),
            logradouro,
            numero,
            complemento,
            bairro,
            cidade,
            estado
        };

        setLoading(true);
        try {
            const response = await api.put(`/clientes/${id}`, {
                cliente,
                endereco
            });
    
            if (response.data.success) {
                setTexto("Cliente atualizado com sucesso!");
                mostrarModal();
                setTimeout(() => {
                    navigate('/menu/clientes');
                }, 2000);
            } else {
                setTexto(response.data.message || "Erro ao atualizar cliente.");
                mostrarModal();
            }
        } catch (error) {
            const mensagemApi = error.response?.data?.message;
            setTexto(mensagemApi || "Erro ao atualizar cliente.");
            mostrarModal();
        } finally {
            setLoading(false);
        }
    };
    
    const handleDataNascimentoChange = (e) => {
        let valor = e.target.value.replace(/\D/g, '');
        if (valor.length > 2 && valor.length <= 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2)}`;
        } else if (valor.length > 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2, 4)}/${valor.slice(4, 8)}`;
        }
        setDataNascimento(valor);
    };

    const handleCpfOuCnpjChange = (e) => {
        const { value } = e.target;
        const sanitizedValue = value.replace(/\D/g, '');

        let valorFormatado = sanitizedValue;

        if (sanitizedValue.length <= 11) {
            valorFormatado = formatadorCPF(sanitizedValue);
            setIsCNPJ(false);
            setRazaoSocial('');
            setInscricaoEstadual('');
            setInscricaoMunicipal('');
        } else if (sanitizedValue.length <= 14) {
            valorFormatado = formatadorCNPJ(sanitizedValue);
            setIsCNPJ(sanitizedValue.length === 14);
        }

        setCpfCnpj(valorFormatado);
    };

    return (
        <section className="container-principal-cadastro-cliente">
            <dialog id="CaixaDeDialogo">
                <div className="conteudo-dialog">
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button onClick={fecharModal}>Ok</button>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <section className="conteudo-cadastro-cliente">
                    <div className="titulo-perfil">
                        <h1>
                            <span>Clientes</span> &gt; Editar de Cliente
                        </h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                </path>
                            </svg>
                            <h2>Salvando...</h2>
                        </div>
                    ) : (
                    <div className="perfil-cadastro-cliente">
                        <h2>Editar de Cliente</h2>
                        <form className="form-cadastro-cliente" onSubmit={atualizarCliente}>
                            <label>Nome: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nome">
                                <input
                                    type="text"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o nome do cliente"
                                    required
                                />
                            </div>

                            <label>CPF/CNPJ: <span className="span-obrigatorio">*</span></label>
                            <div className="input-CpfOuCnpj">
                                <input
                                    type="text"
                                    value={cpfCnpj}
                                    onChange={handleCpfOuCnpjChange}
                                    placeholder="Digite CPF ou CNPJ"
                                />
                            </div>

                            <label>E-mail: <span className="span-obrigatorio">*</span></label>
                            <div className="input-email">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Digite o e-mail"
                                    required
                                />
                            </div>

                            <label>Celular: <span className="span-obrigatorio">*</span></label>
                            <div className="input-celular">
                                <input
                                    type="text"
                                    value={celular}
                                    onChange={(e) => setCelular(mascaraCelular(e.target.value))}
                                    placeholder="Digite o celular"
                                    maxLength={15}
                                    required
                                />
                            </div>

                            <label>Telefone:</label>
                            <div className="input-telefone">
                                <input
                                    type="text"
                                    value={telefone}
                                    onChange={(e) => setTelefone(mascaraTelefone(e.target.value))}
                                    placeholder="Digite o telefone fixo (opcional)"
                                    maxLength={14}
                                />
                            </div>

                            {isCNPJ && (
                                <>
                                    <label>Razão Social:</label>
                                    <div className="input-razaoSocial">
                                        <input
                                            type="text"
                                            value={razaoSocial}
                                            onChange={(e) => setRazaoSocial(e.target.value)}
                                            placeholder="Digite a razão social"
                                            maxLength={255}
                                        />
                                    </div>

                                    <label>Inscrição Estadual: <span className="span-obrigatorio">*</span></label>
                                    <div className="input-inscricaoEstadual">
                                        <input
                                            type="text"
                                            value={inscricaoEstadual}
                                            onChange={(e) => setInscricaoEstadual(e.target.value)}
                                            placeholder="Digite a inscrição estadual"
                                            maxLength={20}
                                            required={isCNPJ}
                                        />
                                    </div>

                                    <label>Inscrição Municipal:</label>
                                    <div className="input-inscricaoMunicipal">
                                        <input
                                            type="text"
                                            value={inscricaoMunicipal}
                                            onChange={(e) => setInscricaoMunicipal(e.target.value)}
                                            placeholder="Digite a inscrição municipal (opcional)"
                                            maxLength={20}
                                        />
                                    </div>
                                </>
                            )}

                            <label>Data de Nascimento:</label>
                            <div className="input-dataNascimento">
                                <input
                                    type="text"
                                    value={dataNascimento}
                                    onChange={handleDataNascimentoChange}
                                    placeholder="DD/MM/AAAA"
                                    maxLength="10"
                                />
                            </div>

                            <label>Sexo:</label>
                            <div className="input-sexo">
                                <select value={sexo} onChange={(e) => setSexo(e.target.value)} required>
                                    <option value="">Selecione</option>
                                    <option value="Masculino">Masculino</option>
                                    <option value="Feminino">Feminino</option>
                                    <option value="Outro">Outro</option>
                                </select>
                            </div>

                            <label>Tipo de Cliente: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nivelAcesso">
                                <select value={tipoCliente} onChange={(e) => setTipoCliente(e.target.value)} required>
                                    <option value="Atacadista">Atacadista</option>
                                    <option value="Varejista">Varejista</option>
                                </select>
                            </div>

                            <label>Status do Cliente: <span className="span-obrigatorio">*</span></label>
                            <div className="input-statusCliente">
                                <select value={statusCliente} onChange={(e) => setStatusCliente(e.target.value)} required>
                                    <option value="Ativo">Ativo</option>
                                    <option value="Inativo">Inativo</option>
                                    <option value="Bloqueado">Bloqueado</option>
                                </select>
                            </div>

                            <div className='linha-1-endereco'>
                                <div className='conteudo-cep'>
                                    <label className='lasbel-cep'>CEP: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-cep'>
                                        <input
                                            type="text"
                                            value={cep}
                                            onChange={(e) => setCep(mascaraCep(e.target.value))}
                                            onBlur={() => buscarEnderecoPorCep(cep.replace(/\D/g, ''))}
                                            maxLength={8}
                                            placeholder="Digite o CEP"
                                        />
                                    </div>
                                </div>

                                <div className='conteudo-numero'>
                                    <label className='lasbel-numero'>Número: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-numero'>
                                        <input
                                            type="text"
                                            value={numero}
                                            onChange={(e) => setNumero(e.target.value)}
                                            placeholder="Digite o Nº"
                                        />
                                    </div>
                                </div>
                            </div>

                            <label>Logradouro:</label>
                            <div className='input-logradouro'>
                                <input
                                    type="text"
                                    value={logradouro}
                                    onChange={(e) => setLogradouro(e.target.value)}
                                    placeholder="Logradouro"
                                    disabled
                                />
                            </div>

                            <label>Bairro:</label>
                            <div className='input-bairro'>
                                <input
                                    type="text"
                                    value={bairro}
                                    onChange={(e) => setBairro(e.target.value)}
                                    placeholder="Bairro"
                                    disabled
                                />
                            </div>

                            <div className='linha-5-endereco'>
                                <div className='conteudo-cidade'>
                                    <label className='lasbel-cidade'>Cidade:</label>
                                    <div className='input-cidade'>
                                        <input
                                            type="text"
                                            value={cidade}
                                            onChange={(e) => setCidade(e.target.value)}
                                            placeholder="Cidade"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className='conteudo-estado'>
                                    <label className='label-estado'>Estado:</label>
                                    <div className='input-estado'>
                                        <input
                                            type="text"
                                            value={estado}
                                            onChange={(e) => setEstado(e.target.value)}
                                            maxLength={2}
                                            placeholder="Estado"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <label>Complemento:</label>
                            <div className='input-complemento'>
                                <input
                                    type="text"
                                    value={complemento}
                                    onChange={(e) => setComplemento(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o complemento (Opcional)"
                                />
                            </div>

                            <button className="bnt-cadastro-cliente" onClick={atualizarCliente}>
                                Editar Cliente
                            </button>
                        </form>
                    </div>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}